import { useEffect, useState } from "react";
import CrudTemplate from "../crudTemplate";
import TipoProdutoService from "../../services/resource/tipoProdutoService";
import GrupoService from "../../services/resource/grupoService";

const grupoService = new GrupoService();

export default function TipoProdutoCrud() {
    const service = new TipoProdutoService();
    const [grupos, setGrupos] = useState([]);

    useEffect(() => {
        grupoService.listarGrupos().then(res => setGrupos(res.data)).catch(() => setGrupos([]));
    }, []);

    const formFields = [
        { name: "id", label: "ID", type: "input", disabled: true, typeText: "number", colSpan: 1 },
        { name: "nome", label: "Nome", type: "input", colSpan: 1 },
        { name: "grupo", label: "Grupo", type: "input", colSpan: 2 },
        { name: "exigeVeiculo", label: "Exige veículo", type: "booleanFooter" },
        {
            name: "grupoAprovacaoCorporativaId",
            label: "Grupo de Aprovação Corporativa",
            type: "dropdown",
            options: grupos,
            optionLabel: "nome",
            optionValue: "id",
            colSpan: 2,
        },
    ];

    const tableColumns = [
        { key: "nome", label: "Nome", bold: true },
        { key: "grupo", label: "Grupo" },
        { key: "exigeVeiculo", label: "Exige veículo", render: v => v ? "Sim" : "Não" },
        { key: "grupoAprovacaoCorporativaNome", label: "Grupo Aprov. Corporativa" },
        { key: "ativo", label: "Ativo", render: v => v ? "Sim" : "Não" },
    ];

    return <CrudTemplate
        title="Gerenciar Tipos de Produto"
        formFields={formFields}
        tableColumns={tableColumns}
        service={service}
        style={{ width: '85%' }}
        modalHeader="Tipo de Produto"
    />;
}
